/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/314-arrow-up-left2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.707 12.293L5.414 4H9a1 1 0 000-2H3a1.002 1.002 0 00-1 1h-.001v6a1 1 0 002 0V5.414l8.293 8.293a.997.997 0 001.414 0 .999.999 0 000-1.414z"/>'
  }
})
